export default __webpack_public_path__ + "static/media/complete.26e1bb14.png";